/**
 * Form Settings
 */
const formSettings = () => {
  const form = document.querySelector('.js-form');
  const formState = document.querySelector('.js-form-state') as any;
  if (!form || !formState) return;
  const formFields = form.querySelectorAll('input:not([type="hidden"])');
  const textAreas = form.querySelectorAll('textarea');
  const selectFields = form.querySelectorAll('.wpcf7-select');
  const fileFields = form.querySelectorAll('.wpcf7-file');

  function setSpanValue(el: any) {
    const formValueStorage = document.querySelectorAll(
      'span[data-value-for]',
    ) as any;
    formValueStorage.forEach((spanElement: any) => {
      if (el.name === spanElement.dataset.valueFor) {
        spanElement.innerText = el.value;
      }
    });
  }

  fileFields.forEach((field: any) => {
    field.addEventListener('change', (e: any) => {
      let file = e.target.files[0];
      let statusEl = e.target.parentNode.parentNode.nextElementSibling;
      let removeFile = statusEl.nextElementSibling;
      if (file.name) {
        statusEl.innerText = file.name;
        removeFile.style.display = 'block';
      } else {
        statusEl.innerText = '選択されていません';
      }
      console.log(parent);
      console.log(file.name);
    });
  });

  formFields.forEach((field: any) => {
    if (field.type === 'checkbox' || field.type === 'radio') {
      field.addEventListener('change', (e: any) => {
        setSpanValue(e.target);
      });
    } else {
      field.addEventListener('input', (e: any) => {
        setSpanValue(e.target);
      });
    }
  });

  textAreas.forEach((textArea) => {
    textArea.addEventListener('input', (e: any) => {
      setSpanValue(e.target);
    });
  });

  selectFields.forEach((select: any) => {
    select.addEventListener('change', (e: any) => {
      setSpanValue(e.target);
    });
  });

  const formSteps = document.querySelector('.entry-form__steps');
  const formProgressSteps = document.querySelectorAll(
    '.entry-form__steps--item',
  );
  const formButtons = formState.querySelectorAll('.js-form-button');
  const contactSection = document.querySelector('section.entry');
  const wpcf7Form = formState.closest('.wpcf7');
  if (!formProgressSteps || !contactSection || !formSteps) return;
  formButtons.forEach((button: any) => {
    button.addEventListener('click', () => {
      switch (button.dataset.action) {
        case 'confirm':
          formState.setAttribute('data-state', 'confirm');
          formProgressSteps.forEach((item: any) => {
            item.classList.remove('is-active');
            item.classList.remove('current');
          });
          formProgressSteps[1].classList.add('is-active');
          formSteps.scrollIntoView({ behavior: 'smooth' });
          break;
        case 'return':
          formState.setAttribute('data-state', 'input');
          formProgressSteps.forEach((item: any) => {
            item.classList.remove('is-active');
            item.classList.remove('current');
          });
          formProgressSteps[0].classList.add('current');
          formProgressSteps[1].classList.add('is-active');
          contactSection.scrollIntoView({ behavior: 'smooth' });
          break;
        default:
          if (wpcf7Form) {
            // Dispatch submit event to CF7
            // wpcf7Form.dispatchEvent(
            //   new Event('submit', { bubbles: true, cancelable: true })
            // );
            const submitButton = wpcf7Form.querySelector(
              'input[type="submit"], button[type="submit"]',
            );
            if (submitButton) {
              submitButton.click();
            }
          }
      }
    });
  });

  // Listen for CF7's AJAX success event
  document.addEventListener(
    'wpcf7mailsent',
    () => {
      // if (event.detail.contactFormId == 'your-form-id') {
      setTimeout(() => {
        const currentHref = window.location.href;
        // @ts-ignore
        location = `${currentHref}/complete/`;
      }, 500);
    },
    false,
  );

  document.addEventListener(
    'wpcf7invalid',
    () => {
      formState.setAttribute('data-state', 'input');
      formProgressSteps[1].classList.remove('active');
      formState.scrollIntoView({ behavior: 'smooth' });
    },
    false,
  );

  const acceptanceCheck = document.querySelector('.terms') as any;
  const confirmButton = formState.querySelector(
    '.button[data-action="confirm"]',
  );
  const requiredFields = document.querySelectorAll(
    '.wpcf7-validates-as-required',
  );
  const uploadCounter = document.querySelector('.dnd-upload-counter');
  if (!acceptanceCheck || !confirm || !requiredFields) return;
  const checkRequiredFields = () => {
    let allFilled = true;

    requiredFields.forEach((field: any) => {
      if (field.type === 'checkbox' || field.type === 'radio') {
        if (!field.checked) {
          allFilled = false;
        }
      } else if (field.nodeName == 'SELECT') {
        if (field.value == '西暦') {
          allFilled = false;
        }
      } else {
        if (field.value.trim() === '') {
          allFilled = false;
        }
      }

      if (field.classList.contains('error')) {
        allFilled = false;
      }
    });

    if (uploadCounter) {
      const count = uploadCounter.querySelector('span');
      if (count) {
        let value = Number(count.innerText);
        if (value <= 0) {
          allFilled = false;
        }
      }
    }

    if (acceptanceCheck) {
      if (!acceptanceCheck.checked) {
        allFilled = false;
      }
    }

    if (allFilled) {
      confirmButton.removeAttribute('disabled');
    } else {
      confirmButton.setAttribute('disabled', 'true');
    }
  };

  requiredFields.forEach((field: any) => {
    field.addEventListener('input', checkRequiredFields);
    field.addEventListener('change', checkRequiredFields);
  });

  if (acceptanceCheck) {
    acceptanceCheck.addEventListener('change', checkRequiredFields);
  }

  // set initial states
  formFields.forEach((field: any) => {
    if (field.type === 'radio' || field.type === 'checkbox') {
      if (field.checked) {
        setSpanValue(field);
      }
    } else {
      setSpanValue(field);
    }
  });

  textAreas.forEach((textAarea) => {
    setSpanValue(textAarea);
  });

  selectFields.forEach((select: any) => {
    setSpanValue(select);
  });

  if (uploadCounter) {
    const observer = new MutationObserver(() => {
      checkRequiredFields();
    });

    observer.observe(uploadCounter, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  checkRequiredFields();
};

export default formSettings;
